<template>
  <div
    v-if="(exhibitorProfile.EnableWebcast || (session.ShowPlaylist && availablePresentations.length > 0)) && webcastAccess && componentVisibility('PlaylistWebcast')"
    class="symposiaPlayerexhb margin-bottom"
    id="pag-exhibitor-player"
  >
    <h4 v-if='showTitle'>{{ title || $t("VMX.webcast_headline") }}</h4>
    <template v-if="customButton.text && customButton.url">
      <p class="exhibitor-symposia-player__custom-button">
        <a
          :href="customButton.url"
          :target="customButton.target ? customButton.target : '_blank'"
        >
          <template v-if="customButton.icon">
            <font-awesome-icon
              :icon="['far', customButton.icon]"
              :size="'1x'"
            />
          </template>
          <span>{{ customButton.text }}</span>
        </a>
      </p>
    </template>
    <div
      v-if="selectedPresentation && showPresentationTitle"
      class="exhibitor-symposia-player__presentations__headline"
    >
      <span
        style="font-weight: 700"
        v-if="selectedPresentation.SpeakerFirstname || selectedPresentation.SpeakerSurname"
      >
        <span v-html="selectedPresentation.SpeakerFirstname" />
        <span v-html="selectedPresentation.SpeakerSurname" />
      </span>
      <span
        style="font-weight: 700"
        v-else-if="selectedPresentation.SpeakerTitleFirstSurname"
        v-html="selectedPresentation.SpeakerTitleFirstSurname"
      />
      <span v-if="selectedPresentation.SpeakerFirstname || selectedPresentation.SpeakerSurname || selectedPresentation.SpeakerTitleFirstSurname">:</span>
      <span v-html="selectedPresentation.Title" />
    </div>
    <div class="exhibitor-symposia-player">
      <div class="exhibitor-symposia-player__player">
        <template v-if="selectedPresentation">
          <div class="is-16by9">
            <presentation-m-events-player
              :key="selectedPresentation.Id"
              :iscarousel="this.exhibitorProfile.UseWebcastPlayerCaroussel"
              :event-id="selectedPresentation.EventId"
              :presentation-id="selectedPresentation.Id"
              :resource="selectedPresentation"
              :thumbnail="thumbnail || selectedPresentation.pThumbnail"
            />
          </div>
        </template>
        <figure
          v-else
          :class="['image is-16by9', compactPlaylistView ? 'is-compact-clickable' : '']"
          @click="selectPresentation(availablePresentations[0], 0)"
        >
          <template v-if="exhibitorProfile.WebcastImage && !exhibitorProfile.UseWebcastPlayerCaroussel">
            <img v-lazy="exhibitorProfile.WebcastImage" />
          </template>
          <template v-else-if="exhibitorProfile.WebcastImage && exhibitorProfile.UseWebcastPlayerCaroussel">
            <img :src="availablePresentations[0]?.pThumbnail || appConfig.placeholderPlayerUrl || thumbnail" />
          </template>
          <template v-else>
            <img v-lazy="uploadedThumbnail || session.ImagePath ||appConfig.placeholderPlayerUrl || thumbnail" />
          </template>
        </figure>
      </div>
      <div class="exhibitor-symposia-player__presentations_playlist">
        <div
          v-if="compactPlaylistView"
          class="exhibitor-symposia-player__presentations_playlist_play"
        >
          {{ `Playlist ${currentlyPlaying + 1}/${availablePresentations.length}` }}
        </div>
        <div class="exhibitor-symposia-player__presentations">
          <div
            :class="['exhibitor-symposia-player__presentations_items', compactPlaylistView ? 'is-compact' : '']"
          >
            <div
              v-for="(presentation, idx) in availablePresentations"
              :key="presentation.Id"
              :class="['exhibitor-symposia-player__presentations__item', compactPlaylistView ? 'is-compact' : '',currentlyPlaying === idx ? 'active' : '' ]"
              @click="selectPresentation(presentation, idx)"
            >
              <font-awesome-icon
                v-if="(compactPlaylistView && currentlyPlaying === idx) || !compactPlaylistView"
                :icon="['fas', compactPlaylistView ? 'play' : 'play-circle']"
                :class="['exhibitor-symposia-player__presentations__item__icon', compactPlaylistView ? 'is-compact' : '']"
                :size="compactPlaylistView ? '1x' : '3x'"
              />
              <div
                v-if="(compactPlaylistView && currentlyPlaying !== idx)"
                :class="['exhibitor-symposia-player__presentations__item__icon', compactPlaylistView ? 'is-compact' : '']"
              >
                {{ idx + 1 }}
              </div>
              <div :class="['exhibitor-symposia-player__presentations__item__box', compactPlaylistView ? 'is-compact' : '']">
                <div
                  :class="['exhibitor-symposia-player__presentations__item__text', compactPlaylistView ? 'is-compact' : 'pl-1 pb-1']"
                >
                  <div
                    class="exhibitor-symposia-player__presentations__item__text__speaker"
                    v-if="presentation.SpeakerFirstname || presentation.SpeakerSurname"
                  >
                    <span> {{ presentation.SpeakerFirstname+' ' +presentation.SpeakerSurname }} </span>
                  </div>
                  <div
                    class="exhibitor-symposia-player__presentations__item__text__speaker"
                    v-else-if="presentation.SpeakerTitleFirstSurname"
                  >
                    <span v-html="presentation.SpeakerTitleFirstSurname" />
                  </div>
                  <div
                    :class="['exhibitor-symposia-player__presentations__item__text__title', compactPlaylistView ? 'is-compact' : '']"
                  >
                    <span v-html="presentation.Title" />
                  </div>
                </div>
              </div>
              <figure :class="['image is-16by9', compactPlaylistView ? 'is-compact' : '']">
                <img
                  :class="[compactPlaylistView ? 'is-compact' : '']"
                  :src="presentation.thumbnail || presentation.pThumbnail"
                  @click="trackSelectWebcast(presentation)"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import dayjs from 'dayjs'
import EventBus from '~/states/event-bus'
import exhibitionApi from '~/api/exhibition'
import accessControl from '~/utilities/accessControl'
import visibilityMixins from '../../mixins/visibilityMixins'

import PresentationMEventsPlayer from './../PresentationMEventsPlayer.vue'
import utils from '../../utilities'


export default {
  name: 'ExhibitorSymposiaPlayer',
  components: { PresentationMEventsPlayer },
  mixins: [
    visibilityMixins,
  ],
  inject: {
    TrackingUtil: {
      type: Function,
    },
  },
  data() {
    return {
      selectedPresentation: null,
      presentations: [],
      meventsPresentations: [],
      currentlyPlaying: null,
    }
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      apiBaseUrl: 'instancesState/getApiBaseUrl',
      superUser: 'instancesState/getSuperUser',
      eventId: 'instancesState/getEventId',
      instance: 'instancesState/getInstance',
    }),
    webcastAccess() {
      return accessControl.accessControlKey('watchWebcast')
    },
    availablePresentations() {
      const tz = utils.eventTimezone()
      dayjs.tz.setDefault(tz)


      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), tz)
      return this.meventsPresentations.filter((pres) => {
        const availabilityDate = dayjs.tz(pres.onDemandAvailability, tz)
        const access = accessControl.accessControlSession(pres.SessionId?.toString())
        if (pres.availabilityTo) {
          const availabilityTo = dayjs.tz(pres.availabilityTo, tz)
          return availabilityDate <= nowDate && nowDate <= availabilityTo && pres.webcastEnabled && pres.path != null
        }
        if (this.superUser) {
          return (
            pres.webcastEnabled
            && pres.path != null
          )
        }

        return (
          access
          && availabilityDate <= nowDate
          && pres.webcastEnabled
          && pres.path != null
        )
      })
    },
    appConfig() {
      const appConfig = this.configForKey('app_config')
      if (appConfig) {
        return appConfig.config[0]
      }
      return null
    },
    manageApiUrl() {
      if (this.appConfig && this.appConfig.VirtualMeetingTestApi) {
        return this.appConfig.VirtualMeetingTestApi
      }
      return this.apiBaseUrl.replace('https://', '')
    },
    virtualMeetingUrl() {
      return this.appConfig ? this.appConfig.VirtualMeetingUrl : null
    },
    liveStreams() {
      const industryConfig = this.configForKey('industry_config').config
      let liveStreamList
      if (industryConfig.liveStreamList?.length > 0) {
        // eslint-disable-next-line max-len
        [liveStreamList] = industryConfig.liveStreamList.filter((list) => list.exhibitorId === this.exhibitorProfile.CompanyAccountId)
        return liveStreamList?.streams
      }
      return []
    },
  },
  props: {
    exhibitorProfile: {
      type: Object,
      default() {
        return {}
      },
    },
    webcastPresentation: {
      type: Array,
      default: null,
    },
    compactPlaylistView: {
      type: Boolean,
      default: false,
    },
    session: {
      type: Object,
      default() {
        return {}
      },
    },
    playlistPlaythrough: {
      type: Boolean,
      default: false,
    },
    disableVMChecksProp: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showPresentationTitle: {
      type: Boolean,
      default: true,
    },
    thumbnail: {
      type: String,
      default: '../../assets/playerDefault.jpg',
    },
    uploadedThumbnail: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    customButton: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    presentations() {
      this.getAllPresentations()
    },
  },
  methods: {
    ...mapActions({
      loadConfig: 'config/loadConfig',
    }),
    async getPresentationThumbnail(
      sessionId,
      presentationId,
      eventId,
      wEnabled,
      onDemandAvailability,
      presentationTitle,
      speakerFirstname,
      speakerSurname,
      speakerTitleFirstSurname,
      permissionForWebcast,
      suppressWebcast,
      disableVMChecks,
      thumbnail,
    ) {
      const url = `${this.virtualMeetingUrl}/v0/resources.json`
      let data = {}
      const params = {
        manage_api: this.manageApiUrl,
        event_manage_id: eventId,
        resource_manage_id: presentationId,
        include_playback: 0,
      }

      const response = await axios.get(url, { params })
      if (response.data && response.data[0]) {
        let webcastEnabled
        if (disableVMChecks) {
          webcastEnabled = wEnabled
            && permissionForWebcast
            && !suppressWebcast
            && response.data[0].is_uploaded
        } else {
          webcastEnabled = wEnabled
            && response.data[0].is_approved
            && response.data[0].is_handled
            && response.data[0].is_uploaded
            && response.data[0].is_published
        }
        if (this.superUser) {
          webcastEnabled = wEnabled && response.data[0].is_uploaded
        }
        data = {
          SessionId: sessionId,
          Id: presentationId,
          Title: presentationTitle,
          SpeakerFirstname: speakerFirstname,
          SpeakerSurname: speakerSurname,
          SpeakerTitleFirstSurname: speakerTitleFirstSurname,
          EventId: eventId,
          onDemandAvailability,
          webcastEnabled,
          permissionForWebcast,
          suppressWebcast,
          disableVMChecks,
          path: response.data[0].path,
          pThumbnail:
            `https://d2t0unnjxes6lt.cloudfront.net/data/${
              response.data[0].app_path
            }/data/talks/${
              response.data[0].path
            }/Slide1.jpg`,
          playerResource: response.data[0],
          thumbnail,
        }
      }
      return data
    },
    selectPresentation(presentation, idx) {
      this.selectedPresentation = presentation
      this.currentlyPlaying = idx
    },
    async getAllPresentations() {
      const calls = []
      const liveStream = []
      if (this.liveStreams?.length > 0) {
        this.liveStreams.forEach((stream) => {
          liveStream.push(
            {
              Id: stream.id,
              Title: stream.title,
              SpeakerFirstname: '',
              SpeakerSurname: stream.topic,
              EventId: this.eventId,
              onDemandAvailability: stream.availableFrom,
              availabilityTo: stream.availableTo,
              webcastEnabled: true,
              path: stream.url,
              pThumbnail: stream.thumbnail,
              playerResource: {
                app_path: this.instance,
                contentsession: {
                  id: stream.id,
                  manage_id: '',
                  room_id: 9999,
                  title: stream.title,
                },
                event_id: '',
                id: stream.id,
                is_approved: true,
                is_handled: true,
                is_published: true,
                is_uploaded: true,
                jpg_path: '',
                manage_id: '',
                mediatype_id: 99,
                not_available_reason: '',
                path: stream.url,
                resourcetype_id: 99,
                title: stream.title,
                availabilityFrom: stream.availableFrom,
                availabilityTo: stream.availableTo,
              },
            },
          )
        })
      }
      this.presentations.forEach((p) => {
        if (!p.SuppressWebcast || !p.Suppresswebcast) {
          calls.push(
            this.getPresentationThumbnail(
              p.CurrentSessionId || this.session.SessionId,
              p.Id || p.PresentationId,
              p.EventId || this.eventId,
              p.webcastEnabled || p.WebcastEnabled,
              p.onDemandAvailability || p.OnDemandAvailability,
              p.Title || p.Text,
              p.SpeakerFirstname || '',
              p.SpeakerSurname || '',
              p.Speakers?.length > 0 ? p.Speakers[0].TitleFirstnameSurname : '',
              p.PermissionForWebcast || p.WebCastPermission,
              p.SuppressWebcast || p.Suppresswebcast,
              this.disableVMChecksProp,
              p.Thumbnail,
            ),
          )
        }
      })

      return Promise.all(calls).then((results) => {
        this.meventsPresentations = liveStream.concat(results)
      })
    },
    reloadComponent() {
      if (this.selectedPresentation !== null && this.selectedPresentation.playerResource.resourcetype_id === 99) {
        this.selectedPresentation = null
      }
      this.getAllPresentations()
      clearInterval(this.timer)
      if (this.liveStreams.length > 0) {
        this.getTimeForReload()
      }
    },
    loadStylesheet(url) {
      const ss = document.styleSheets
      for (let i = 0, max = ss.length; i < max; i += 1) {
        if (ss[i].href === url) {
          return
        }
      }
      const link = document.createElement('link')
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute('href', url)
      document.head.appendChild(link)
    },
    getTimeForReload() {
      const tz = utils.eventTimezone()
      dayjs.tz.setDefault(tz)
      const serverTime = this.$store.getters['serverTime/getTime']
      const nowDate = dayjs.tz(dayjs(serverTime), tz)
      const times = []
      let closestDateTo = null
      this.liveStreams.forEach((stream) => {
        if (dayjs.tz(stream.availableTo, tz).diff(nowDate) >= 0) {
          times.push(dayjs.tz(stream.availableTo, tz).diff(nowDate))
        }
        if (dayjs.tz(stream.availableFrom, tz).diff(nowDate) >= 0) {
          times.push(dayjs.tz(stream.availableFrom, tz).diff(nowDate))
        }
      })

      if (times.length > 0) {
        closestDateTo = times.reduce((a, b) => (a - nowDate.valueOf() < b - nowDate.valueOf() ? a : b))
      }
      if (closestDateTo) {
        this.timer = setInterval(this.reloadComponent, closestDateTo)
      }
    },
    trackSelectWebcast(presentation) {
      this.TrackingUtil.trackEvent(
        'SelectWebcast',
        'Select',
        `${this.exhibitorProfile.Name
        } (${
          presentation.Title
        }, ${
          presentation.Id
        })`,
      )
    },
  },
  async created() {
    this.$loadScript('https://unpkg.com/swiper/swiper-bundle.js').then(() => {}).catch(() => {
      console.log('failed load swiper-bundle.js')
    })
    this.$loadScript('https://unpkg.com/swiper/swiper-bundle.min.js').then(() => {}).catch(() => {
      console.log('failed load swiper-bundle.min.js')
    })
    this.loadStylesheet('https://unpkg.com/swiper/swiper-bundle.css')
    this.loadStylesheet('https://unpkg.com/swiper/swiper-bundle.min.css')
  },
  async mounted() {
    if (this.exhibitorProfile.UseWebcastPlayerCaroussel) {
      if (this.webcastPresentation) {
        this.presentations = this.webcastPresentation
      }
    } else if (this.session.ShowPlaylist && this.session.Presentations) {
      this.presentations = await this.session.Presentations
    } else {
      if('CompanyAccountId' in this.exhibitorProfile){
      this.presentations = await exhibitionApi.getExhibitorPresentations(
        this.exhibitorProfile.CompanyAccountId,
      )
      }

    }

    if (this.liveStreams?.length > 0) {
      this.getTimeForReload()
    }
    await this.loadConfig()

    if (this.session.ShowPlaylist && this.playlistPlaythrough) {
      EventBus.$on('videoEnded', (params) => {
        if(this.currentlyPlaying + 1 !== this.availablePresentations.length) {
          this.selectPresentation(this.availablePresentations[this.currentlyPlaying + 1], this.currentlyPlaying + 1)
        }
      })
    }
  },
}
</script>

<style lang="scss">
.margin-bottom {
  margin-bottom: 30px;
}
.exhibitor-symposia-player {
  display: flex;

  @media (max-width: 992px) {
    flex-direction: column;
  }

  .exhibitor-symposia-player__player {
    flex: 0 0 calc(75% - 10px);
    width: calc(75% - 10px);
    margin-right: 20px;
    padding-bottom: 50px;

    @media (max-width: 992px) {
      width: 100%;
      padding-bottom: 60px;
    }
  }

  .exhibitor-symposia-player__presentations_playlist {
    display: flex;
    width: 100%;
    flex-direction: column;
    @media (max-width: 992px) {
      height: 300px;
    }
  }

  .exhibitor-symposia-player__presentations_playlist_play {
    background: #EBEBEB;
    padding: 5px;
    font-weight: bold;
  }

  .exhibitor-symposia-player__presentations {
    flex: 1 0 calc(100% - 45px);
    position: relative;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.5);
      -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
  }

  .exhibitor-symposia-player__presentations_items {
    position: absolute;
    height: auto;
    width: 100%;
    top: 0;
    left: 0;
    @media (max-width: 992px) {
      &:not(.is-compact){
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px 10px;
      }
    }
  }

  .exhibitor-symposia-player__presentations__item {
    cursor: pointer;
    position: relative;
  }

  .exhibitor-symposia-player__presentations__item__box {
    position: absolute;
    color: var(--primary-industry-contrast);
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;

    &.is-compact {
      left: 134px;
      top: 0;
    }
  }

  .exhibitor-symposia-player__presentations__item__text {
    font-size: 12px;
    background-color: var(--primary-industry);

    &.is-compact{
      background-color: transparent;
      color: #262626;
    }
  }

  .exhibitor-symposia-player__presentations__item__text__speaker {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .exhibitor-symposia-player__presentations__item__text__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.is-compact{
      display: -webkit-box;
      -webkit-line-clamp: 2;
      white-space: initial;
      -webkit-box-orient: vertical;
    }
  }

  .exhibitor-symposia-player__presentations__item__icon {
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    &.is-compact{
      color: #262626;
      left: 10px;
      font-size: 14px;
      font-weight: 700;
    }
  }

  @media (max-width: 1200px) {
    .exhibitor-symposia-player__presentations__item__text {
      font-size: 10px;
    }
  }

  @media (max-width: 750px) {
    .exhibitor-symposia-player__presentations__item__icon {
      font-size: 30px;
    }
  }

  .exhibitor-symposia-player__presentations__item:not(:last-child) {
    margin-bottom: 20px;
  }
  .exhibitor-symposia-player__presentations__item {
    &.is-compact {
     margin: 0;
     background: #EBEBEB;
    }

    &.active {
      background: #FDFDFD;
    }
  }
}

.exhibitor-symposia-player__presentations__headline {
  color: var(--primary-industry-contrast);
  font-size: 20px;
  background-color: var(--primary-industry);
  padding: 5px 5px;
  margin-bottom: 5px;
}

.exhibitor-symposia-player__custom-button {
  a {
    padding: 8px 16px;
    color: var(--primary-industry-contrast);
    background-color: var(--primary-industry);
    -webkit-appearance: button;
    -moz-appearance: button;
    text-decoration: none;
    svg {
      margin-right: 15px;
    }
  }
}
</style>
